(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rudemen-pack-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const more = event.target.closest('[data-rm-more]');
    if (more) {
      more.closest('[data-rm-panel]').classList.add('is-expanded');
      more.setAttribute('aria-expanded', 'true');
      more.hidden = true;
      return;
    }
    const tab = event.target.closest('[data-rm-tab]');
    if (!tab) return;
    const selector = tab.closest('[data-rm-pack-selector]');
    const group = tab.dataset.rmTab;
    selector.querySelectorAll('[data-rm-tab]').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    selector.querySelectorAll('[data-rm-panel]').forEach((panel) => panel.classList.toggle('m:hidden', panel.dataset.rmPanel !== group));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rudemen-product-media-mobile"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rm-mobile-gallery]').forEach((gallery) => {
    const viewport = gallery.querySelector('[data-rm-gallery-viewport]');
    const progress = gallery.querySelector('[data-rm-gallery-progress]');
    if (!viewport || !progress) return;
    const updateProgress = () => {
      const maximum = viewport.scrollWidth - viewport.clientWidth;
      const available = viewport.clientWidth * 0.82;
      const position = maximum > 0 ? viewport.scrollLeft / maximum : 0;
      const activeSlide = Math.round(viewport.scrollLeft / viewport.clientWidth);
      viewport.classList.toggle('is-single-slide', activeSlide > 0);
      progress.style.transform = `translateX(${position * available}px)`;
    };
    viewport.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  });
  } catch(e) { console.error(e); }
})();

})();
